module.exports = "<head>\n  <link rel=\"stylesheet\" href=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.css\" />\n  <script src=\"https://unpkg.com/leaflet@1.6.0/dist/leaflet.js\"></script>\n\n\n</head>\n\n</head>\n<navbar></navbar>\n\n<body>\n  <div id=\"container\">\n        <div id=\"sidebar\">\n          \n        </div>\n        <div id=\"map\"></div>\n      </div>\n\n\n</body>\n<footer></footer>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/mapa/mapa.html
// module id = 759
// module chunks = 0